/* Plk World — Home: interazioni
   Ogni modulo parte dagli attributi data-plk-* e si riavvia nell'editor del tema. */
(() => {
  const ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touch = window.matchMedia('(hover: none)').matches;
  // scorre veloce e poi rallenta fino ad atterrare (si ferma se tocchi o usi la rotella)
  let scorriRaf = 0;
  const scorriA = (y, ms = 1300) => {
    cancelAnimationFrame(scorriRaf);
    y = Math.max(0, Math.min(y, document.documentElement.scrollHeight - innerHeight));
    if (ridotto) { scrollTo(0, y); return; }
    const y0 = scrollY, dy = y - y0, t0 = performance.now();
    const ferma = () => { cancelAnimationFrame(scorriRaf); off(); };
    const off = () => ['wheel', 'touchstart', 'keydown'].forEach(ev => removeEventListener(ev, ferma));
    ['wheel', 'touchstart', 'keydown'].forEach(ev => addEventListener(ev, ferma, { passive: true }));
    const passo = now => {
      const t = Math.min((now - t0) / ms, 1);
      const e = 1 - Math.pow(1 - t, 5);           // parte forte, atterra piano
      scrollTo(0, y0 + dy * e);
      if (t < 1) scorriRaf = requestAnimationFrame(passo); else off();
    };
    scorriRaf = requestAnimationFrame(passo);
  };
  const lerp = (a, b, t) => a + (b - a) * t;

  /* ---------- 1 · Il vicolo ---------- */
  function vicolo(el) {
    if (el.__plk) return; el.__plk = true;
    const box = el.querySelector('.plk-vicolo__box');
    const buio = el.querySelector('.plk-vicolo__buio');
    const torcia = el.querySelector('.plk-vicolo__torcia');
    const ingressi = [...el.querySelectorAll('[data-ingresso]')];
    let tx = 0, ty = 0, cx = 0, cy = 0;       // rotazione: obiettivo / attuale (-1..1)
    let lx = .5, ly = .45, clx = .5, cly = .45; // torcia: obiettivo / attuale (0..1)
    let visibile = true, t0 = performance.now(), frame = 0;
    let guida = 'auto';                      // 'auto' | 'mouse' | 'dito'
    let fermo = 0;
    let r = el.getBoundingClientRect();      // misura in cache: niente letture nel ciclo
    const pista = el.closest('.plk-vicolo-pista--cammina');
    const ui = el.querySelector('.plk-vicolo__ui');
    const uscita = el.querySelector('.plk-vicolo__uscita');
    let cam = 0, ccam = 0;                    // quanto sei entrato nel vicolo (0..1)
    let porte = [];                           // dove stanno le porte, in proporzione al vicolo (0..1)
    const misuraPorte = () => {
      porte = ingressi.map(a => { const b = a.getBoundingClientRect(); return [(b.left - 20 - r.left) / r.width, (b.right + 20 - r.left) / r.width, (b.top - 20 - r.top) / r.height, (b.bottom + 20 - r.top) / r.height]; });
    };
    const misura = () => {
      r = el.getBoundingClientRect();
      if (pista && !ridotto) {
        const pr = pista.getBoundingClientRect();
        cam = Math.min(Math.max(-pr.top / Math.max(pr.height - r.height, 1), 0), 1);
      }
    };
    // le misure si prendono all'inizio del fotogramma, prima di scrivere: niente ricalcoli forzati
    let daMisurare = true;
    const chiedi = () => { daMisurare = true; sveglia(); };
    window.addEventListener('resize', chiedi, { passive: true });
    window.addEventListener('scroll', chiedi, { passive: true });

    requestAnimationFrame(() => el.classList.add('is-pronta'));

    const punta = (x, y) => {
      const nx = Math.min(Math.max((x - r.left) / r.width, 0), 1);
      const ny = Math.min(Math.max((y - r.top) / r.height, 0), 1);
      tx = (nx - .5) * 2; ty = (ny - .5) * 2; lx = nx; ly = ny;
      sveglia();
    };
    el.addEventListener('mousemove', e => { guida = 'mouse'; punta(e.clientX, e.clientY); }, { passive: true });
    el.addEventListener('mouseleave', () => { if (guida === 'mouse') { guida = 'auto'; t0 = performance.now(); } });
    const tocco = e => { const t = e.touches[0]; if (!t) return; guida = 'dito'; fermo = 0; punta(t.clientX, t.clientY); };
    el.addEventListener('touchstart', e => { if (!porte.length || daMisurare) { misura(); misuraPorte(); } tocco(e); }, { passive: true });
    el.addEventListener('touchmove', tocco, { passive: true });
    el.addEventListener('touchend', () => { fermo = performance.now(); }, { passive: true });

    new IntersectionObserver(([e]) => { visibile = e.isIntersecting; el.classList.toggle('is-fuori', !visibile); if (visibile) chiedi(); }).observe(el);

    // porte accese: solo conti sui numeri già misurati, nessuna lettura della pagina
    const accesa = new Array(ingressi.length).fill(false);
    const accendi = () => {
      porte.forEach((b, i) => {
        const on = clx > b[0] && clx < b[1] && cly > b[2] && cly < b[3];
        if (on !== accesa[i]) { accesa[i] = on; ingressi[i].classList.toggle('is-acceso', on); }
      });
    };
    const spegni = () => ingressi.forEach((a, i) => { accesa[i] = false; a.classList.remove('is-acceso'); });

    let raf = 0, ultimo = '';
    const giro = (now) => {
      raf = 0;
      if (!visibile) return;                 // fuori schermo: il ciclo si ferma del tutto
      if (daMisurare) { daMisurare = false; misura(); }
      if (guida === 'dito' && fermo && now - fermo > 2500) { guida = 'auto'; fermo = 0; t0 = now; spegni(); }
      if (guida === 'auto') {
        const t = (now - t0) / 1000;
        lx = .5 + Math.sin(t * .45) * .28; ly = .48 + Math.sin(t * .9) * .14;
        if (touch) { tx = Math.sin(t * .45) * .35; ty = Math.sin(t * .9) * .2; }
      }
      const k = guida === 'dito' ? .35 : guida === 'mouse' ? .2 : .12;
      cx = lerp(cx, tx, .07); cy = lerp(cy, ty, .07);
      clx = lerp(clx, lx, k); cly = lerp(cly, ly, k);
      ccam = lerp(ccam, cam, .14);
      const e = ccam * ccam * (3 - 2 * ccam);          // morbido all'inizio e alla fine
      const box3d = ridotto ? '' : `translateZ(calc(var(--d) * ${(-.14 + e * .52).toFixed(4)})) rotateX(${(cy * 5 * (1 - e * .6)).toFixed(2)}deg) rotateY(${(cx * -10 * (1 - e * .6)).toFixed(2)}deg)`;
      const pos = `translate3d(${(r.width * clx).toFixed(1)}px, ${(r.height * cly).toFixed(1)}px, 0)`;
      const stato = box3d + pos + e.toFixed(3);
      if (stato !== ultimo) {                          // scrive solo se qualcosa è cambiato davvero
        ultimo = stato;
        if (!ridotto) box.style.transform = box3d;
        if (pista) {
          ui.style.opacity = Math.max(0, 1 - e * 3).toFixed(3);
          ui.style.transform = `translate3d(0, ${(-e * 60).toFixed(1)}px, 0)`;
          uscita.style.opacity = Math.max(0, (e - .55) / .3).toFixed(3);
        }
        buio.style.transform = pos + ' scale(2)'; torcia.style.transform = pos;
      }
      if (guida === 'dito' && porte.length && (++frame % 4 === 0)) accendi();
      // continua solo se c'è ancora movimento (in automatico la torcia gira sempre)
      if (guida === 'auto' || stato !== '' && (Math.abs(cx - tx) + Math.abs(cy - ty) + Math.abs(clx - lx) + Math.abs(cly - ly) + Math.abs(ccam - cam) > .0005) || (guida === 'dito' && fermo)) sveglia();
    };
    function sveglia() { if (!raf && visibile) raf = requestAnimationFrame(giro); }
    sveglia();

    // Rompere il vetro
    const vetro = el.querySelector('[data-emergenza]');
    const muro = el.querySelector('[data-muro-fondo]');
    vetro?.addEventListener('click', () => {
      [vetro, muro].forEach(n => n?.classList.remove('is-rotto'));
      el.classList.remove('is-scossa'); void vetro.offsetWidth;
      [vetro, muro].forEach(n => n?.classList.add('is-rotto'));
      if (!ridotto) el.classList.add('is-scossa');
      clearTimeout(vetro.__t);
      vetro.__t = setTimeout(() => { [vetro, muro].forEach(n => n?.classList.remove('is-rotto')); el.classList.remove('is-scossa'); }, 5000);
      // ogni vetro rotto è come mezzo swipe in su: al terzo sei dentro il sito
      if (pista && !ridotto) {
        const su = pista.getBoundingClientRect().top + scrollY;
        const fine = su + pista.offsetHeight - el.offsetHeight + innerHeight * .35; // oltre il vicolo, dentro il sito
        const tot = Math.max(fine - su, 1);
        const fatto = Math.min(Math.max((scrollY - su) / tot, 0), 1);
        const passo = Math.min(3, Math.floor(fatto * 3 + .08) + 1);
        scorriA(su + tot * passo / 3, 650);
      }
    });
  }

  /* ---------- 2 · Tre porte: la foto segue il cursore ---------- */
  function porte(el) {
    if (el.__plk || touch) return; el.__plk = true;
    const prev = el.querySelector('.plk-porte__anteprima');
    if (!prev) return;
    document.body.appendChild(prev); // fuori da overflow:hidden
    let x = 0, y = 0, px = 0, py = 0, on = false;
    el.querySelectorAll('[data-porta]').forEach(riga => {
      riga.addEventListener('pointerenter', () => {
        prev.querySelectorAll('[data-img]').forEach(i => i.toggleAttribute('data-attiva', i.dataset.img === riga.dataset.porta));
        prev.classList.add('is-attiva'); on = true;
      });
      riga.addEventListener('pointerleave', () => { prev.classList.remove('is-attiva'); on = false; });
    });
    el.addEventListener('pointermove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
    const giro = () => {
      px = lerp(px, x, .18); py = lerp(py, y, .18);
      if (on || prev.classList.contains('is-attiva')) prev.style.left = px + 'px', prev.style.top = py + 'px';
      requestAnimationFrame(giro);
    };
    requestAnimationFrame(giro);
  }

  /* ---------- 3 · Il drop: la cover cambia sulla traccia ---------- */
  function drop(el) {
    if (el.__plk) return; el.__plk = true;
    const covers = el.querySelectorAll('[data-cover]');
    const mostra = (id) => covers.forEach(c => c.toggleAttribute('data-attiva', c.dataset.cover === id));
    el.querySelectorAll('[data-traccia]').forEach(t => {
      const on = () => { mostra(t.dataset.traccia); el.querySelectorAll('.plk-traccia').forEach(x => x.classList.toggle('is-attiva', x === t)); };
      t.addEventListener('pointerenter', on); t.addEventListener('focusin', on);
    });
    el.querySelector('.plk-tracklist')?.addEventListener('pointerleave', () => { mostra('drop'); el.querySelectorAll('.plk-traccia').forEach(x => x.classList.remove('is-attiva')); });
  }

  /* ---------- 5 · La storia: orizzontale mentre scendi ---------- */
  function storia(el) {
    if (el.__plk) return; el.__plk = true;
    const pista = el.querySelector('.plk-storia-h__pista');
    const rullo = el.querySelector('.plk-storia-h__rullo');
    const barra = el.querySelector('.plk-storia-h__barra span');
    // misure in cache: mentre scorri niente letture del layout, solo un transform per frame
    let su = 0, corsa = 1, extra = 0, largo = 0, alto = 0, raf = 0, ultimo = -1;
    const misura = (forza) => {
      if (ridotto) { pista.style.removeProperty('--pista'); return; }
      // su telefono la barra del browser che appare/sparisce cambia l'altezza: non ricalcoliamo per quello
      const w = window.innerWidth, h = window.innerHeight;
      if (forza || w !== largo || Math.abs(h - alto) > 160) {
        largo = w; alto = h;
        extra = Math.max(rullo.scrollWidth - w, 0);
        pista.style.setProperty('--pista', (h + extra) + 'px');
        el.style.setProperty('--extra', extra);
      }
      su = pista.getBoundingClientRect().top + window.scrollY;
      corsa = Math.max(pista.offsetHeight - alto, 1);
    };
    const disegna = () => {
      raf = 0;
      const p = Math.min(Math.max((window.scrollY - su) / corsa, 0), 1);
      if (Math.abs(p - ultimo) < .0005) return;
      ultimo = p;
      rullo.style.transform = `translate3d(${(-p * extra).toFixed(1)}px,0,0)`;
      if (barra) barra.style.transform = `scaleX(${p.toFixed(4)})`;
    };
    // se il browser sa animare con lo scroll (Chrome, Safari recenti) il movimento lo fa lui, fuori dal JS: niente scatti
    const nativo = window.CSS && CSS.supports('animation-timeline: view()') && CSS.supports('view-timeline-name: --x');
    if (nativo) el.classList.add('is-nativa');
    const scorri = () => { if (!ridotto && !nativo && !raf) raf = requestAnimationFrame(disegna); };
    // l'anno che passa al centro si riempie
    const io = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-attiva', e.isIntersecting)), { rootMargin: '0px -47% 0px -47%' });
    el.querySelectorAll('.plk-tappa:not(.plk-tappa--fine)').forEach(t => io.observe(t));
    misura(true); if (!nativo) disegna();
    // quando la storia sta per arrivare ricontrolla dove si trova (le foto sopra possono averla spostata)
    new IntersectionObserver(([e]) => { if (e.isIntersecting) { misura(false); ultimo = -1; scorri(); } }, { rootMargin: '50% 0px' }).observe(el);
    window.addEventListener('resize', () => { misura(false); ultimo = -1; scorri(); }, { passive: true });
    window.addEventListener('scroll', scorri, { passive: true });
    window.addEventListener('load', () => { misura(true); ultimo = -1; if (!nativo) disegna(); });
  }


  /* ---------- Collezione: vista, filtro per tipo, schede che si inclinano ---------- */
  function collezione(el) {
    if (el.__plk) return; el.__plk = true;
    const vista = el.querySelectorAll('[data-vista]');
    const metti = v => {
      el.classList.toggle('is-grande', v === 'grande');
      vista.forEach(b => b.setAttribute('aria-pressed', b.dataset.vista === v));
      try { localStorage.setItem('plk-vista', v); } catch (_) {}
    };
    let salvata = null; try { salvata = localStorage.getItem('plk-vista'); } catch (_) {}
    if (salvata) metti(salvata);
    vista.forEach(b => b.addEventListener('click', () => metti(b.dataset.vista)));
    const pills = el.querySelectorAll('[data-tipo]:is(button)');
    const celle = el.querySelectorAll('.plk-griglia__cella');
    pills.forEach(p => p.addEventListener('click', () => {
      pills.forEach(x => x.setAttribute('aria-pressed', x === p));
      celle.forEach(c => { c.hidden = !(p.dataset.tipo === '*' || c.dataset.tipo === p.dataset.tipo); });
    }));
    const cursore = el.querySelector('[data-cursore]');
    if (touch || ridotto || !cursore) return;
    let raf = 0, x = 0, y = 0;
    const muovi = () => { raf = 0; cursore.style.transform = `translate3d(${x}px,${y}px,0)`; };
    el.querySelectorAll('.plk-scheda').forEach(a => {
      a.addEventListener('mouseenter', () => { cursore.classList.add('is-on'); cursore.classList.toggle('is-verde', !!a.querySelector('.plk-targhetta--bottiglia')); });
      a.addEventListener('mouseleave', () => { cursore.classList.remove('is-on'); a.style.transform = ''; });
      a.addEventListener('mousemove', e => {
        const r = a.getBoundingClientRect();
        const nx = (e.clientX - r.left) / r.width - .5, ny = (e.clientY - r.top) / r.height - .5;
        a.style.transform = `perspective(900px) rotateX(${(-ny * 6).toFixed(2)}deg) rotateY(${(nx * 8).toFixed(2)}deg)`;
        x = e.clientX; y = e.clientY; if (!raf) raf = requestAnimationFrame(muovi);
      });
    });
  }


  /* ---------- Eventi: conto alla rovescia per le prossime date ---------- */
  function eventi(el) {
    if (el.__plk) return; el.__plk = true;
    const oggi = new Date(); oggi.setHours(0, 0, 0, 0);
    el.querySelectorAll('.plk-prossimo[data-data]').forEach(p => {
      const d = new Date(p.dataset.data + 'T00:00:00');
      if (isNaN(d)) return;
      const g = Math.round((d - oggi) / 864e5);
      const c = p.querySelector('[data-conto]');
      if (!c) return;
      const LT = window.plkT || {}; c.textContent = g > 1 ? (LT.tra_giorni || 'Tra {g} giorni').replace('{g}', g) : g === 1 ? (LT.domani || 'Domani') : g === 0 ? (LT.oggi_li || 'Oggi. Ci vediamo lì') : (LT.passato || 'Appena passato');
    });
  }


  /* ---------- Anteprima Lifestyle: numeri che contano, conto alla rovescia, mattoncini che si inclinano ---------- */
  function anteprima(el) {
    if (el.__plk) return; el.__plk = true;
    const strada = el.querySelector('[data-data]');
    if (strada && strada.dataset.data) {
      const oggi = new Date(); oggi.setHours(0, 0, 0, 0);
      const d = new Date(strada.dataset.data + 'T00:00:00');
      const g = Math.round((d - oggi) / 864e5);
      const c = strada.querySelector('[data-conto]');
      if (c && !isNaN(g)) { const LT = window.plkT || {}; c.textContent = g > 1 ? (LT.tra_giorni || 'Tra {g} giorni').replace('{g}', g) : g === 1 ? (LT.domani || 'Domani') : g === 0 ? (LT.oggi || 'Oggi') : (LT.prossima || 'Prossima data'); }
    }
    const numeri = el.querySelectorAll('[data-conta]');
    if (numeri.length && !ridotto) {
      numeri.forEach(n => { n.textContent = '0'; });
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return; io.disconnect();
        const t0 = performance.now();
        const passo = now => {
          const t = Math.min((now - t0) / 1400, 1), k = 1 - Math.pow(1 - t, 3);
          numeri.forEach(n => { n.textContent = Math.round(+n.dataset.conta * k); });
          if (t < 1) requestAnimationFrame(passo);
        };
        requestAnimationFrame(passo);
      }, { threshold: .4 });
      io.observe(el.querySelector('.plk-lsa__tile--record'));
    }
    if (touch || ridotto) return;
    el.querySelectorAll('.plk-lsa__tile').forEach(t => {
      t.addEventListener('mousemove', e => {
        const r = t.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        t.style.transform = `perspective(1000px) rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 6).toFixed(2)}deg)`;
      });
      t.addEventListener('mouseleave', () => { t.style.transform = ''; });
    });
  }

  /* ---------- Storia completa: l'anno attivo nella barra ---------- */
  function capitoli(el) {
    if (el.__plk) return; el.__plk = true;
    const links = el.querySelectorAll('[data-anno-link]');
    if (!links.length) return;
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) links.forEach(l => {
        const on = l.dataset.annoLink === e.target.id;
        l.classList.toggle('is-attivo', on);
        if (on) l.parentElement.scrollTo({ left: l.offsetLeft - l.parentElement.clientWidth / 2 + l.offsetWidth / 2, behavior: 'smooth' });
      });
    }), { rootMargin: '-45% 0px -50% 0px' });
    el.querySelectorAll('[data-capitolo]').forEach(c => io.observe(c));
    const atterra = id => { const c = document.getElementById(id); if (c) scorriA(c.getBoundingClientRect().top + scrollY - (innerWidth < 750 ? 120 : 150)); };
    links.forEach(l => l.addEventListener('click', e => { e.preventDefault(); history.replaceState(null, '', '#' + l.dataset.annoLink); atterra(l.dataset.annoLink); }));
    // arrivi dalla home con l'anno nell'indirizzo: parti dall'alto e atterri sull'anno
    const h = decodeURIComponent(location.hash.slice(1));
    if (h && document.getElementById(h)) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      scrollTo(0, 0); requestAnimationFrame(() => scrollTo(0, 0));
      setTimeout(() => atterra(h), 450);
    }
  }

  /* ---------- Il nastro: scorre sempre, accelera quando scorri ---------- */
  function nastro(el) {
    if (el.__plk) return; el.__plk = true;
    const piste = [...el.querySelectorAll('[data-nastro]')].map(n => ({ n, dir: +n.dataset.nastro, x: 0, w: 0 }));
    const misura = () => piste.forEach(p => { p.w = p.n.firstElementChild.offsetWidth; });
    misura(); window.addEventListener('resize', misura, { passive: true });
    let visibile = false, y = scrollY, ultimoY = y, spinta = 0, prima = performance.now(), raf = 0;
    // la posizione della pagina si legge solo quando scorri (non a ogni fotogramma: costringeva il telefono a ricalcolare tutto)
    window.addEventListener('scroll', () => { y = scrollY; }, { passive: true });
    const giro = (now) => {
      raf = 0;
      if (!visibile || ridotto) return;      // fuori schermo il nastro si ferma
      const dt = Math.min(now - prima, 50); prima = now;
      const dy = y - ultimoY; ultimoY = y;
      spinta = lerp(spinta, Math.min(Math.abs(dy) * .6, 14), .1);
      piste.forEach(p => {
        p.x -= p.dir * (dt * .04 + spinta);
        if (p.w) { p.x %= p.w; if (p.x > 0) p.x -= p.w; }
        p.n.style.transform = `translate3d(${p.x.toFixed(1)}px,0,0)`;
      });
      raf = requestAnimationFrame(giro);
    };
    new IntersectionObserver(([e]) => {
      visibile = e.isIntersecting;
      if (visibile && !raf) { prima = performance.now(); ultimoY = y; raf = requestAnimationFrame(giro); }
    }).observe(el);
  }

  /* ---------- Titoli: una parola alla volta ---------- */
  function parole(root) {
    root.querySelectorAll('.plk-sez__head .plk-h2, .plk-storia-h__head .plk-h2, .plk-capitoli__head .plk-h1, .plk-capitoli__fine').forEach(h => {
      if (h.dataset.parole) return; h.dataset.parole = '1';
      let i = 0;
      const walk = (node) => [...node.childNodes].forEach(c => {
        if (c.nodeType === 3) {
          const frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(w => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            const o = document.createElement('span'); o.className = 'plk-parola';
            const d = document.createElement('span'); d.textContent = w; d.style.setProperty('--i', i++);
            o.appendChild(d); frag.appendChild(o);
          });
          c.replaceWith(frag);
        } else if (c.nodeType === 1) walk(c);
      });
      walk(h);
      if (!h.closest('.plk-rivela')) h.classList.add('plk-rivela');
    });
  }

  /* ---------- Vlog: il video parte solo al click ---------- */
  function vlog(el) {
    if (el.__plk) return; el.__plk = true;
    el.querySelectorAll('[data-yt]').forEach(sch => {
      const via = () => {
        if (sch.querySelector('iframe')) return;
        const f = document.createElement('iframe');
        f.src = `https://www.youtube-nocookie.com/embed/${sch.dataset.yt}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true; f.title = 'Vlog Plk World';
        sch.appendChild(f); sch.classList.add('is-in-play');
      };
      sch.querySelector('.plk-vlog__play')?.addEventListener('click', via);
      sch.querySelector('.plk-vlog__cover')?.addEventListener('click', via);
    });
  }

  /* ---------- Guinness: i numeri contano da zero ---------- */
  function record(el) {
    if (el.__plk) return; el.__plk = true;
    const cifre = el.querySelectorAll('[data-conta]');
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return; io.unobserve(e.target);
      const n = e.target, fine = parseInt(n.dataset.conta, 10);
      if (isNaN(fine) || ridotto) return;
      const t0 = performance.now(), dur = 1400;
      const passo = (t) => { const p = Math.min((t - t0) / dur, 1); n.textContent = Math.round(fine * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(passo); };
      requestAnimationFrame(passo);
    }), { threshold: .6 });
    cifre.forEach(c => io.observe(c));
  }

  /* ---------- FAQ: argomenti, ricerca, fisarmonica morbida ---------- */
  function faq(el) {
    if (el.__plk) return; el.__plk = true;
    const voci = [...el.querySelectorAll('.plk-faq__voce')];
    const gruppi = [...el.querySelectorAll('[data-faq-gruppo]')];
    const pills = el.querySelectorAll('[data-faq-arg]');
    const cerca = el.querySelector('[data-faq-cerca]');
    const nessuna = el.querySelector('[data-faq-nessuna]');
    let arg = '*';
    const norm = t => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const filtra = () => {
      const q = norm(cerca?.value.trim() || '');
      let visibili = 0;
      gruppi.forEach(g => {
        const okArg = arg === '*' || g.dataset.faqGruppo === arg;
        let n = 0;
        g.querySelectorAll('.plk-faq__voce').forEach(v => {
          const ok = okArg && (!q || norm(v.textContent).includes(q));
          v.hidden = !ok; if (ok) n++;
          if (q && ok) v.open = true;
        });
        g.hidden = n === 0; visibili += n;
      });
      if (nessuna) nessuna.hidden = visibili > 0;
    };
    pills.forEach(p => p.addEventListener('click', () => { pills.forEach(x => x.setAttribute('aria-pressed', x === p)); arg = p.dataset.faqArg; filtra(); }));
    cerca?.addEventListener('input', filtra);
    // una sola risposta aperta per volta
    voci.forEach(v => v.addEventListener('toggle', () => { if (v.open && !(cerca && cerca.value)) voci.forEach(x => { if (x !== v) x.open = false; }); }));
  }

  /* ---------- Comparsa allo scroll ---------- */
  function rivela(root) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visibile'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
    root.querySelectorAll('.plk-rivela:not(.is-visibile)').forEach(n => io.observe(n));
  }

  /* ---------- Foto più vive: entrata a tendina + collage che galleggia ---------- */
  const FOTO = '.plk-capitolo__foto figure, .plk-record__foto figure, .plk-evento__foto, .plk-storia-pezzo__foto, .plk-fase-v__foto, .plk-vlog__schermo';
  const FLUTTUA = '.plk-capitolo__foto--due figure:nth-child(2), .plk-record__f2';
  let fluttuano = [];
  function foto(root) {
    const piano = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const nuove = [...root.querySelectorAll(FOTO)].filter(f => !f.classList.contains('plk-foto-entra'));
    if (!piano && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-dentro'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      nuove.forEach(f => {
        // nei collage la seconda foto entra un attimo dopo la prima
        const fratelli = f.parentElement ? [...f.parentElement.children].filter(x => x.matches(FOTO)) : [];
        f.style.setProperty('--fi', Math.max(0, fratelli.indexOf(f)));
        f.classList.add('plk-foto-entra');
        io.observe(f);
      });
    }
    if (piano) return;
    fluttuano = [...new Set([...fluttuano.filter(f => f.isConnected), ...document.querySelectorAll(FLUTTUA)])];
    if (!foto.__ascolto) {
      foto.__ascolto = true;
      let attesa = false;
      const muovi = () => {
        attesa = false;
        const h = innerHeight;
        // prima tutte le letture, poi tutte le scritture: niente ricalcoli a ogni foto
        const rs = fluttuano.map(f => f.getBoundingClientRect());
        fluttuano.forEach((f, i) => {
          const r = rs[i];
          if (r.bottom < -100 || r.top > h + 100) return;
          // da -1 (in basso nello schermo) a 1 (in alto): la foto sale un po' più lenta della pagina
          const p = ((r.top + r.height / 2) - h / 2) / h;
          f.style.setProperty('--fl', (p * 46).toFixed(1) + 'px');
        });
      };
      const chiedi = () => { if (!attesa) { attesa = true; requestAnimationFrame(muovi); } };
      addEventListener('scroll', chiedi, { passive: true });
      addEventListener('resize', chiedi);
      chiedi();
    }
  }

  /* ---------- Schermata di caricamento tra una pagina e l'altra ---------- */
  function velo() {
    const v = document.getElementById('cc-veil');
    if (!v || !v.classList.contains('plk-velo')) return;
    const subito = (fn) => { v.classList.add('is-subito'); fn(); void v.offsetWidth; requestAnimationFrame(() => v.classList.remove('is-subito')); };
    // finita l'uscita, il velo torna pronto a entrare di nuovo dall'alto a sinistra
    v.addEventListener('transitionend', e => {
      if (e.target.classList.contains('plk-velo__strato--verde') && !v.classList.contains('-in')) subito(() => v.classList.remove('is-arrivo'));
    });
    const scopri = () => document.documentElement.classList.remove('plk-coperto', 'plk-coperto-velo', 'plk-velo-attivo');
    const esci = () => { v.classList.remove('is-subito'); scopri(); requestAnimationFrame(() => v.classList.remove('-in')); };
    window.addEventListener('pageshow', e => {
      if (e.persisted) { scopri(); subito(() => v.classList.remove('-in', 'is-arrivo')); return; } // tornando indietro: via subito
      if (v.classList.contains('is-arrivo')) setTimeout(esci, 120);
    });
    if (document.readyState === 'complete' && v.classList.contains('is-arrivo')) setTimeout(esci, 120);
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.closest('[data-modal-toggle],[data-modal-nav-toggle]')) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return; // ancore nella stessa pagina
      if (/^\/(cart|checkout|account)/.test(url.pathname) && a.closest('form')) return;
      e.preventDefault();
      v.classList.remove('is-arrivo', 'is-subito');
      void v.offsetWidth;
      v.classList.add('-in');
      document.documentElement.classList.add('plk-velo-attivo');
      try { sessionStorage.setItem('plk-velo', '1'); } catch (_) {}
      // si cambia pagina solo quando il velo ha coperto tutto (sul telefono la navigazione congela il disegno)
      let via = false;
      const vai = () => { if (via) return; via = true; document.documentElement.classList.add('plk-coperto-velo'); location.href = url.href; };
      v.querySelector('.plk-velo__strato--pieno')?.addEventListener('transitionend', vai, { once: true });
      setTimeout(vai, 760);
      setTimeout(() => { scopri(); v.classList.remove('-in'); }, 8000); // sicurezza
    });
  }
  velo();

  /* ---------- Preferenze cookie: il link nel footer riapre il banner di Shopify ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#preferenze-cookie"]');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    const apri = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else location.href = '/pages/cookie-policy';
    };
    if (window.privacyBanner) apri();
    else if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], apri);
    else apri();
  }, true);

  /* ---------- Il menu Plk ---------- */
  function menu() {
    const m = document.querySelector('[data-plk-menu]');
    if (!m || m.__plk) return; m.__plk = true;
    const apri = document.querySelectorAll('[data-plk-menu-apri]');
    let prima = null;
    const stato = (on) => {
      m.classList.toggle('is-aperto', on);
      m.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('plk-menu-aperto', on);
      // telefono: a menu aperto la pagina sotto sparisce, così non si vede dietro le barre del browser
      clearTimeout(m.__copri);
      if (on) m.__copri = setTimeout(() => document.documentElement.classList.add('plk-coperto'), 760);
      else document.documentElement.classList.remove('plk-coperto');
      apri.forEach(a => a.setAttribute('aria-expanded', on));
      if (on) { prima = document.activeElement; setTimeout(() => m.querySelector('[data-plk-menu-chiudi]')?.focus(), 50); }
      else prima?.focus?.();
    };
    apri.forEach(a => a.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); stato(true); }, true));
    m.querySelector('[data-plk-menu-chiudi]')?.addEventListener('click', () => stato(false));
    document.addEventListener('keydown', e => {
      if (!m.classList.contains('is-aperto')) return;
      if (e.key === 'Escape') stato(false);
      if (e.key === 'Tab') { // il focus resta dentro il menu
        const f = [...m.querySelectorAll('a, button')].filter(x => x.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    // col dito: la parola gira in corsivo, poi si cambia pagina
    m.querySelectorAll('a.plk-menu__link').forEach(a => a.addEventListener('click', e => {
      if (!matchMedia('(hover: none)').matches || e.metaKey || e.ctrlKey || e.shiftKey || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      a.classList.add('is-tocco');
      setTimeout(() => { location.href = a.href; }, 450);
    }));
    window.addEventListener('pageshow', () => m.querySelectorAll('.is-tocco').forEach(x => x.classList.remove('is-tocco')));
    window.addEventListener('pageshow', () => stato(false));
  }
  menu();

  const moduli = { vicolo, porte, drop, storia, capitoli, nastro, vlog, record, faq, collezione, eventi, anteprima };
  const avvia = (root = document) => {
    parole(root);
    root.querySelectorAll('[data-plk]').forEach(el => moduli[el.dataset.plk]?.(el));
    rivela(root);
    foto(root);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => avvia()) : avvia();
  document.addEventListener('shopify:section:load', e => avvia(e.target));
})();
